module.exports = __webpack_public_path__ + "assets/img/block-right-a9a3b367.png";